import React from "react";
import {SignIn as SignInPage} from "serpotrack-frontend-authentication";
// @ts-ignore
import logo from "../../../assets/img/icon.svg";
import router from "../../../routing/Router";
import AuthFormFooterSignIn from "../../widgets/auth/AuthFormFooterSignIn";

const SignIn = () => {
    return (
        <SignInPage
            logo={logo}
            onSignedInRedirectTo={router.dashboard.absolutePath()}
            forgotPasswordUrl={"https://app.serpotrack.com/auth/reset"}
            footer={<AuthFormFooterSignIn/>}
        />
    );
};

export default SignIn;